function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect, useLayoutEffect, useRef, forwardRef } from "react";
import { isFunction } from "lodash-es";
import { Input } from "semantic-ui-react";
import { NumberFormat, isValidNumber } from "../../helpers";
import { useForceUpdate } from "../../helpers/hooks";
const formatValue = value => isValidNumber(value) ? NumberFormat.format(value) : value;
const CurrencyInput = /*#__PURE__*/forwardRef((props, forwardRef) => {
  const [value, setValue] = useState(() => formatValue(props.value));
  const [selectionStart, setSelectionStart] = useState(0);
  const [selectionEnd, setSelectionEnd] = useState(0);
  const ref = useRef();
  if (isFunction(forwardRef)) {
    forwardRef(ref.current);
  }
  const domNode = ref.current?.inputRef;
  const [, forceUpdate] = useForceUpdate();
  useEffect(() => {
    if (domNode === undefined) {
      forceUpdate();
    }
  }, [domNode === undefined]);
  useLayoutEffect(() => {
    if (!domNode || !domNode.current) return;
    const hasFocus = domNode.current.contains(document.activeElement);
    if (!hasFocus) {
      setValue(formatValue(props.value));
    } else {
      domNode.current.setSelectionRange(selectionStart, selectionEnd);
    }
  }, [props.value]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref
  }, props, {
    value: value,
    onChange: (event, data) => {
      const e = {
        ...event
      };
      const newData = {
        ...data
      };
      let {
        value
      } = e.target;
      const {
        selectionStart,
        selectionEnd
      } = domNode.current;
      setSelectionStart(selectionStart);
      setSelectionEnd(selectionEnd);
      setValue(value);
      value = value.replace(/[,$]/g, "");
      e.target.value = newData.value = value;
      if (isFunction(props.onChange)) {
        props.onChange(e, newData);
      }
    }
  }));
});
CurrencyInput.displayName = "CurrencyInput";
CurrencyInput.propTypes = {
  ...Input.propTypes
};
CurrencyInput.defaultProps = {
  ...Input.defaultProps
};
export default CurrencyInput;
//# sourceMappingURL=CurrencyInput.js.map